import React, { useState } from 'react';
import styles from './Faqlp.module.css'; 

const Faqlp: React.FC = () => {
  // Starea pentru a reține întrebările deschise
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  // Funcția care gestionează click-ul pe o întrebare
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={styles.faqQuestions}>
      <div className={styles.sectiontitleFaq}>FAQ</div>

      <div className={styles.accordion}>
        {accordionData.map((item, index) => (
          <div className={styles.accordionItem} key={index}>
            <button className={styles.accordionButton} onClick={() => toggleAccordion(index)}>
              {item.question} 
              <span className={styles.toggle}>{openIndex === index ? '-' : '+'}</span>
            </button>
            <div className={`${styles.accordionContent} ${openIndex === index ? styles.open : ''}`}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>

      <a href="#start"><button className={styles.contactButton}>Need more info? Let's talk!</button></a>
    </section>
  );
};

// Datele pentru întrebare și răspuns
const accordionData = [
  {
    question: 'How do EV charging stations work?',
    answer: 'EV charging stations act as a bridge between the electrical grid and electric vehicles. They convert alternating current (AC) from the grid into direct current (DC) that EV batteries can use. Public stations often feature DC fast chargers, enabling rapid charging in a matter of minutes. The process is simple: drivers connect their vehicles to the station, and power flows to the vehicle\'s battery charging system. Once finished, they disconnect, allowing the next vehicle to charge. For home installations, the charging station is typically integrated directly into the house\'s electrical system.'
  },
  {
    question: 'How can installing EV chargers boost my hospitality business?',
    answer: 'Installing EV chargers enhances your guest satisfaction by offering eco-conscious travelers a convenient and essential amenity. Many guests prioritize hotels that provide dependable EV charging, and by meeting this need, your hotel can foster guest loyalty, encourage return visits, and even lead to extended stays. In addition to guest satisfaction, EV chargers generate new revenue streams through charging fees. By listing your EV amenities on travel platforms, you also increase visibility, attracting more guests and boosting occupancy rates. It\'s a future-focused investment that benefits both your guests and your bottom line.'
  },
  {
    question: 'Are EV charging stations worth it?',
    answer: 'Absolutely! EV charging stations are a smart investment with substantial long-term benefits. They future-proof your business as electric vehicle adoption rises, positioning you for success in an evolving market. The cost efficiency of EVs translates to significant fuel savings for fleet operators. Most importantly, these stations boost customer engagement by attracting and retaining EV owners who prefer businesses with convenient charging options. When investing in charging infrastructure, you\'re not only embracing sustainability but also opening new avenues for growth and customer loyalty, making your business a preferred destination in the electric future.'
  },
  {
    question: 'Can owning an EV charger station be profitable?',
    answer: 'Yes, EV charging stations can be a lucrative venture. They provide a steady stream of income through charging fees. As the electric vehicle market expands to meet growing consumer demand and sustainability goals, the need for charging stations will increase, potentially boosting your profits. Strategic placement of charging stations in high-traffic areas like shopping centers, restaurants, and entertainment venues can enhance the charging experience for users while maximizing your return on investment.'
  },
  {
    question: 'Why should I consider installing an EV charger station?',
    answer: 'Installing an EV charging station positions your business as forward-thinking and environmentally conscious. As EV adoption rises, you\'ll be ahead of the curve in meeting customer needs. Additionally, charging stations can generate income through various means such as usage fees, subscription models, or premium parking rates. They also tend to increase foot traffic and customer spending, especially in retail and hospitality settings.'
  },
  {
    question: 'What types of EV charging stations do you offer?',
    answer: (
      <>
        Energy5 provides a variety of charging solutions for both commercial and residential applications:
        <ul className={styles.faqList}>
          <li>For commercial properties, we offer Level 2 AC chargers and DC fast chargers.</li>
          <li>For residential use, we have smart home charging stations that can be installed indoors or outdoors.</li>
          <li>Our product line includes various form factors such as pedestals, wall-mounted units, and portable options to suit different installation needs.</li>
        </ul>
        We can help you determine the best solution based on your specific requirements and location.
      </>
    )
  },
  {
    question: 'Is any maintenance for EV charging stations required?',
    answer: (
      <>
        Yes, regular maintenance is crucial to ensure optimal performance, safety, and longevity of EV charging stations. This typically includes:
        <ul className={styles.faqList}>
          <li>Routine cleaning of connectors and ports to remove debris</li>
          <li>Regular inspections for loose connections or faults</li>
          <li>Software updates to enhance performance and security</li>
          <li>Periodic checks of electrical components</li>
        </ul>
        Energy5 offers full maintenance services to keep your charging stations in top condition and minimize downtime.
      </>
    )
  },
  {
    question: 'What support services do you offer?',
    answer: (
      <>
        At Energy5, we pride ourselves on providing end-to-end support for our clients:
        <ul className={styles.faqList}>
          <li>24/7 customer support through multiple channels</li>
          <li>Professional installation services</li>
          <li>Ongoing maintenance and repair</li>
          <li>Remote monitoring to ensure continuous functionality</li>
          <li>Regular over-the-air software updates</li>
          <li>Training resources for customers and partners</li>
          <li>Assistance with permitting and paperwork</li>
          <li>Help with incentive acquisition</li>
        </ul>
        Our goal is to deliver a reliable, hassle-free EV charging experience with round-the-clock assistance, ensuring your charging infrastructure operates efficiently for years to come.
      </>
    )
  }
];

export default Faqlp;
